import { useEffect } from 'react'
import { useAuth } from '@/auth'
import { apiClient } from '@/utils/api'

/**
 * Hook to setup authenticated API calls
 * Must be used within a component wrapped by Auth0Provider
 * 
 * The API client uses app tokens (with embedded permissions) when available,
 * falling back to Auth0 tokens for profile creation.
 */
export function useAuthenticatedApi() {
  const { getAccessToken, refreshAccessToken, isAuthenticated } = useAuth()

  // Set token getter synchronously so it's available immediately
  // This ensures other hooks that depend on apiClient have access to the token
  if (isAuthenticated) {
    apiClient.setTokenGetter(getAccessToken, refreshAccessToken)
  } else {
    apiClient.clearTokenGetter()
  }

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      apiClient.clearTokenGetter()
    }
  }, [])

  return apiClient
}
